/* eslint-disable */
/**
 * SPA
 * API serving data for the SPA
 *
 * The version of the OpenAPI document is present in runtime.ts
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { BreadcrumbItemTypeConstants } from './BreadcrumbItemTypeConstants';
import {
    BreadcrumbItemTypeConstantsFromJSON,
    BreadcrumbItemTypeConstantsFromJSONTyped,
    BreadcrumbItemTypeConstantsToJSON,
} from './BreadcrumbItemTypeConstants';

/**
 * Items, either of type Breadcrumb or HierarchyGroup
 * @export
 * @interface BreadcrumbItem
 */
export interface BreadcrumbItem {
    /**
     * 
     * @type {BreadcrumbItemTypeConstants}
     * @memberof BreadcrumbItem
     */
    type: BreadcrumbItemTypeConstants;
}

/**
 * Check if a given object implements the BreadcrumbItem interface.
 */
export function instanceOfBreadcrumbItem(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "type" in value;

    return isInstance;
}

export function BreadcrumbItemFromJSON(json: any): BreadcrumbItem {
    return BreadcrumbItemFromJSONTyped(json, false);
}

export function BreadcrumbItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): BreadcrumbItem {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'type': BreadcrumbItemTypeConstantsFromJSON(json['type']),
    };
}

export function BreadcrumbItemToJSON(value?: BreadcrumbItem | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'type': BreadcrumbItemTypeConstantsToJSON(value.type),
    };
}

